
import IndexComponent from "../../../../components/postcard_rewards/logs/Index.vue";

export default {
  components: {
    IndexComponent,
  },
};
